<template>
  <div class="time">
    <div v-if="numberOfQuestion > 0" class="item">
      <span class="gray">{{ questionText }}:</span>
      <span>{{ `${numberOfQuestion}/${countQuestions}` }}</span>
    </div>

    <div v-if="numberOfQuestion === 0" class="item">
      <span class="gray">{{ questionText }}:</span>
      <span>{{ `${countQuestions}` }}</span>
    </div>

    <div v-if="inited > 0" class="item" :class="{ 'one-item': !questionText }">
      <span class="gray">{{ $tr(`interview.tests.questions.timer`) }}:</span>
      <span v-if="time_left > 3600" :class="{ 'red-color': left_10 }">
        {{ $moment.duration(time_left, 'seconds').format('HH:mm:ss') }}
      </span>
      <span v-else :class="{ 'red-color': left_10 }">{{ time_left | mm_ss }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Timer',

  props: {
    inited: {
      type: [Number],
      default: 0
    },

    current: {
      type: [Number],
      default: null
    },

    label: {
      type: [String, Number],
      default: ''
    },

    questions: {
      type: [String],
      required: true
    },

    numberOfQuestion: {
      type: [Number],
      default: 0
    },

    countQuestions: {
      type: [Number],
      default: 0
    },

    stop_time: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      time_left: null,
      timer_id: null,
      timeout: null,
      preparationTimeStamp: null
    };
  },

  computed: {
    /* считаем 10% от оставшегося времени с округлением */
    left_10() {
      return Number(((this.time_left / this.inited) * 100).toFixed(0)) <= 10;
    },

    questionText() {
      if (this.numberOfQuestion === 0) {
        return this.$tr('interview.tests.questions.questions');
      } else {
        return this.$tr('interview.tests.questions.question');
      }
    }
  },

  watch: {
    stop_time(v) {
      if (v) {
        this.stop_timer();
      } else {
        this.start_timer();
      }
    }
  },

  created() {
    this.start_timer();
  },

  methods: {
    start_timer() {
      if (this.inited > 0) {
        this.preparationTimeStamp = new Date().getTime();

        if (this.current && this.time_left === null) {
          this.time_left = this.current;
        } else if (this.inited && this.time_left === null) {
          this.time_left = this.inited;
        }
        this.timeout = this.time_left;

        this.timer_id = setInterval(() => {
          const current_time = new Date();
          const diff_timestamp = (current_time.getTime() - this.preparationTimeStamp) / 1000;
          this.time_left =
            this.timeout - Math.floor(diff_timestamp) <= 0 ? 0 : this.timeout - Math.floor(diff_timestamp);

          if (this.time_left <= 0) {
            clearInterval(this.timer_id);
            this.$emit('end_time');
          }
        }, 1000);
      }
    },

    stop_timer() {
      clearInterval(this.timer_id);
    }
  }
};
</script>

<style lang="scss" scoped>
.time {
  background: white;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 22px;
  font-size: 15px;
  letter-spacing: 0.005em;
  z-index: 1;
  box-sizing: border-box;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
  .item {
    white-space: nowrap;
    padding: 0;
    font-size: 15px;
    line-height: 24px;
    color: #233346;
    .gray {
      display: inline-block;
      color: #9faab6;
      vertical-align: bottom;
    }
    &.one-item .gray {
      max-width: 60vw;
    }
    .red-color {
      color: #ff594f;
    }

    &:before {
      content: '|';
      color: #cfd4db;
      display: inline-block;
      padding: 0 16px;
      line-height: 16px;

      @media (max-width: 767px) {
        display: none;
      }
    }
    &:first-child:before {
      display: none;
    }
  }
}
</style>
